module.exports = __webpack_public_path__ + "img/slider_7.e4041e39.jpg";